import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";

export default function CommentSearch({ onSearch, value }) {
  const [localValue, setLocalValue] = useState(value || "");
  const [debounceTimer, setDebounceTimer] = useState(null);

  // Sync with parent value
  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    // Clear previous timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    // Set new timer
    const timer = setTimeout(() => {
      onSearch(newValue);
    }, 500);
    
    setDebounceTimer(timer);
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      placeholder="Search"
      value={localValue}
      onChange={handleInputChange}
    />
  );
}